<script setup lang="ts">
import moment from 'moment'
import { computed } from 'vue'

interface Props {
  value: string | Date
}

const props = defineProps<Props>()

const dateString = computed(() => {
  return moment(props.value).format('YYYY-MM-DD')
})

const timeString = computed(() => {
  return moment(props.value).format('HH:mm:ss')
})
</script>

<template>
  <div class="datetime-formated">
    <div class="date">{{dateString}}</div>
    <div class="time">{{timeString}}</div>
  </div>
</template>

<style lang="scss">
.datetime-formated{
  display: flex;
  align-items: flex-end;
  row-gap: 0px;
  column-gap: 7px;

  .date{
    font-size: 12px;
    font-weight: 500;
  }
  .time{
    font-size: 10px;
    font-weight: 300;
  }
}
.table-responsive{
  .datetime-formated{
    flex-direction: column;
    word-break: keep-all;
    white-space: nowrap;
    align-items: flex-start;
  }
}

</style>
